import { render, staticRenderFns } from "./MensalidadesValorBruto.vue?vue&type=template&id=3b51031a&scoped=true&"
import script from "./MensalidadesValorBruto.vue?vue&type=script&lang=js&"
export * from "./MensalidadesValorBruto.vue?vue&type=script&lang=js&"
import style0 from "./MensalidadesValorBruto.vue?vue&type=style&index=0&id=3b51031a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51031a",
  null
  
)

export default component.exports